"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualSettingsButtonStyle = void 0;
const typestyle_1 = require("typestyle");
const panel = () => ({
    display: 'none', position: 'absolute', right: '-38px', bottom: '48px',
    minWidth: '180px', padding: '4px 6px', backgroundColor: 'rgba(0, 0, 0, 0.82)',
    fontSize: '13px', flexFlow: 'column'
});
const item = () => ({ cursor: 'pointer', padding: '5px 6px', margin: '2px 0' });
exports.VisualSettingsButtonStyle = (0, typestyle_1.stylesheet)({
    visuals: { position: 'relative' },
    button: { fontSize: '23px', lineHeight: '18px', textAlign: 'center' },
    panel: Object.assign({}, panel()),
    panelOpen: Object.assign(Object.assign({}, panel()), { display: 'flex' }),
    title: { padding: '5px 6px', fontWeight: 'bold', borderBottom: '1px solid #777', marginTop: '2px' },
    item: Object.assign(Object.assign({}, item()), { $nest: { '&:hover': { backgroundColor: 'rgba(255,255,255,0.12)' } } }),
    itemSelected: Object.assign(Object.assign({}, item()), { backgroundColor: 'rgba(255,255,255,0.22)' }),
    slider: { display: 'flex', alignItems: 'center', gap: '6px', padding: '5px 6px', $nest: { '& input': { width: '68px', accentColor: '#e94560' }, '& b': { minWidth: '24px', textAlign: 'right', fontSize: '11px' } } }
});
